import styled from 'styled-components'

type AlignsType =
  | 'start'
  | 'center'
  | 'space-between'
  | 'space-around'
  | 'space-evenly'
  | 'flex-end'
  | 'flex-start'

interface FlexPropsType {
  flexDirection?: 'row' | 'column'
  flexWrap?: 'wrap' | 'nowrap' | 'wrap-reverse'
  justifyContent?: AlignsType
  alignContent?: Omit<AlignsType, 'space-evenly'>
  alignItems?:
    | 'stretch'
    | 'center'
    | 'start'
    | 'end'
    | 'flex-end'
    | 'flex-start'
  margin?: string
  padding?: string
  width?: string
  maxWidth?: string
  height?: string
  maxHeight?: string
  overflowY?: 'visible' | 'hidden' | 'scroll' | 'auto'
  overflowX?: 'visible' | 'hidden' | 'scroll' | 'auto'
  flex?: string | number
  position?: 'absolute' | 'fixed' | 'sticky' | 'relative'
  grow?: string | number
  zIndex?: string | number
  isolation?: 'isolate' | 'auto'
  border?: string
  bgColor?: string
  gridColumn?: string
  gap?: string
  rowGap?: string
  colGap?: string
}

const Flex = styled.div<FlexPropsType>`
  display: flex;
  /* defaults */
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: stretch;
  /* flex specific props */
  ${({ flexDirection }) =>
    flexDirection &&
    `
      flex-direction: ${flexDirection};
    `}
  ${({ flexWrap }) =>
    flexWrap &&
    `
      flex-wrap: ${flexWrap};
    `}
  ${({ justifyContent }) =>
    justifyContent &&
    `
      justify-content: ${justifyContent};
    `}
  ${({ alignContent }) =>
    alignContent &&
    `
      align-content: ${alignContent};
    `}
  ${({ alignItems }) =>
    alignItems &&
    `
      align-items: ${alignItems};
    `}
  /* generic props */
  ${({ margin }) =>
    margin &&
    `
      margin: ${margin};
    `}
  ${({ padding }) =>
    padding &&
    `
      padding: ${padding};
    `}
  ${({ width }) =>
    width &&
    `
      width: ${width};
    `}
  ${({ maxWidth }) =>
    maxWidth &&
    `
      max-width: ${maxWidth};
    `}
  ${({ height }) =>
    height &&
    `
      height: ${height};
    `}
  ${({ maxHeight }) =>
    maxHeight &&
    `
      max-height: ${maxHeight};
    `}
  ${({ overflowY }) =>
    overflowY &&
    `
      overflow-y: ${overflowY};
    `}
  ${({ overflowX }) =>
    overflowX &&
    `
      overflow-x: ${overflowX};
    `}
  ${({ flex }) =>
    flex &&
    `
      flex: ${flex};
    `}
  ${({ position }) =>
    position &&
    `
      position: ${position};
    `}
  ${({ grow }) =>
    grow &&
    `
      flex-grow: ${grow};
    `}
  ${({ zIndex }) =>
    zIndex &&
    `
      z-index: ${zIndex};
    `}
  ${({ isolation }) =>
    isolation &&
    `
    isolation: ${isolation};
    `}
  ${({ border }) =>
    border &&
    `
      border: ${border};
    `}
  ${({ bgColor }) =>
    bgColor &&
    `
      background: ${bgColor};
    `}
  ${({ gridColumn }) =>
    gridColumn &&
    `
      grid-column: ${gridColumn};
    `}
  ${({ gap }) =>
    gap &&
    `
      gap: ${gap};
    `}
  ${({ rowGap }) =>
    rowGap &&
    `
      row-gap: ${rowGap};
    `}
  ${({ colGap }) =>
    colGap &&
    `
      column-gap: ${colGap};
    `}
`

export default Flex
